import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Auglýsendur">
            <p>
                &Ouml;llum einstaklingum og l&ouml;ga&eth;ilum, er heimilt a&eth; augl&yacute;sa
                &aacute; 1819.is og &iacute; 1819 appinu. Augl&yacute;singar &aacute; vefnum eru
                samkv&aelig;mt gjaldskr&aacute; 1819, eins og h&uacute;n er birt hverju sinni.
            </p>
            <p>
                1819 &aacute;skilur s&eacute;r r&eacute;tt til a&eth; hafna bei&eth;ni um
                augl&yacute;singu, leitaror&eth; e&eth;a skr&aacute;ningu, ef l&iacute;kur eru
                &aacute; &thorn;v&iacute; a&eth; skr&aacute;ningin samr&aelig;mist ekki l&ouml;gum.
                &Aacute;byrg&eth;in er augl&yacute;senda fyrir &ouml;llum leitaror&eth;um og
                skr&aacute;ningum sem &thorn;eir velja og fyrir &ouml;llu tj&oacute;ni sem
                &thorn;v&iacute; kann a&eth; bera.
            </p>
            <p>
                Skr&aacute;ningar a&eth;ila, &thorn;.m.t. fyrirt&aelig;kja, og allt efni sem birt er
                fr&aacute; augl&yacute;sendum hj&aacute; 1819 er &aacute;vallt &aacute;
                &aacute;byrg&eth; augl&yacute;senda.
            </p>{" "}
        </InfoSection>
    );
}
export default ServiceNumber;
